<template>
  <div class="pt-5">
    <v-alert v-if="procesando" type="info" class="mb-4">
      El archivo se está procesando. Por favor espera a que termine para ver el
      resultado.
      <v-progress-circular
        indeterminate
        size="14"
        width="2"
        color="white"
        class="mr-2"
      />
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="jobs"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      no-data-text="No hay procesos registrados"
      loading-text="Cargando procesos..."
    >
      <template #item.status="{ item }">
        <v-chip
          small
          dark
          :color="getStatusColor(item.status)"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular
            v-if="item.status === 'PROCESSING'"
            indeterminate
            size="14"
            width="2"
            color="white"
            class="mr-2"
          />
          {{ getStatusDisplay(item) }}
        </v-chip>
      </template>

      <template #item.errores="{ item }">
        <div class="celda-errores justify-center">
          <span
            class="numero-errores"
            :class="{ 'red--text': item.errores > 0 }"
            @click="item.errores > 0 && abrirErrores(item)"
          >
            {{ item.errores || 0 }}
          </span>
          <v-icon
            v-if="item.errores > 0"
            small
            class="icono-ojo"
            @click="abrirErrores(item)"
          >
            mdi-eye
          </v-icon>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogErrores" max-width="800">
      <v-card>
        <v-card-title>
          Detalle de errores - Archivo
          {{ jobSeleccionado ? jobSeleccionado.nombreArchivo : "" }}
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersErrores"
            :items="erroresJob"
            :loading="loadingErrores"
            dense
            no-data-text="No hay errores registrados"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            dark
            color="#00a7e4"
            rounded
            class="mr-2"
            @click="dialogErrores = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getErroresJobEmisionesMasivas,
  getJobsEmisionesBetterHistorico,
  getJobsEmisionesBetterProcesando,
} from "@/services/emision/emision.service";

export default {
  data() {
    return {
      jobs: [],
      loading: false,
      procesando: false,
      pollingInterval: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Alianza", value: "alianzaNombre" },
        { text: "Producto", value: "productoNombre" },
        { text: "Archivo", value: "nombreArchivo" },
        { text: "Inicio", value: "fechaInicio" },
        { text: "Fin", value: "fechaFin" },
        { text: "Accionado por", value: "agenteNombre" },
        { text: "Total Registros", value: "totalRegistros" },
        { text: "Procesados", value: "procesados" },
        { text: "Errores", value: "errores" },
        { text: "Status", value: "status" },
      ],
      dialogErrores: false,
      erroresJob: [],
      loadingErrores: false,
      jobSeleccionado: null,
      headersErrores: [
        { text: "Fila", value: "fila" },
        { text: "Mensaje", value: "mensaje" },
      ],
    };
  },
  async mounted() {
    await this.actualizarProcesos();
  },
  beforeDestroy() {
    this.detenerPolling();
  },
  methods: {
    async actualizarProcesos() {
      this.loading = true;
      try {
        const [historico, enProceso] = await Promise.all([
          getJobsEmisionesBetterHistorico(),
          getJobsEmisionesBetterProcesando(),
        ]);
        this.jobs = this.combinarJobs(historico, enProceso);

        if (Array.isArray(enProceso) && enProceso.length > 0) {
          this.iniciarPolling();
        } else {
          this.detenerPolling();
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("No se pudieron consultar los procesos.");
      } finally {
        this.loading = false;
      }
    },
    combinarJobs(historico, enProceso) {
      const jobsPorId = new Map();
      const todos = [
        ...(Array.isArray(enProceso) ? enProceso : []),
        ...(Array.isArray(historico) ? historico : []),
      ];

      todos.forEach((job) => {
        if (!jobsPorId.has(job.id)) jobsPorId.set(job.id, job);
      });

      return Array.from(jobsPorId.values());
    },
    registrarJob() {
      this.iniciarPolling();
    },
    iniciarPolling() {
      if (this.pollingInterval) return;

      this.procesando = true;
      this.pollingInterval = setInterval(this.consultarProcesando, 15000);
    },
    async consultarProcesando() {
      try {
        const enProceso = await getJobsEmisionesBetterProcesando();
        if (!Array.isArray(enProceso) || enProceso.length === 0) {
          this.detenerPolling();
          await this.actualizarProcesos();
          return;
        }

        this.jobs = this.combinarJobs(this.jobs, enProceso);
      } catch (error) {
        console.error(error);
        this.detenerPolling();
      }
    },
    detenerPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      this.procesando = false;
    },
    getStatusColor(status) {
      switch (status) {
        case "PROCESSING":
          return "blue";
        case "COMPLETED":
          return "green";
        case "COMPLETED_WITH_ERRORS":
          return "orange";
        case "FAILED":
          return "red";
        default:
          return "grey";
      }
    },
    getStatusDisplay(item) {
      if (item.status === "PROCESSING") {
        if (item.totalRegistros > 0) {
          const procesados = (item.procesados || 0) + (item.errores || 0);
          const porcentaje = Math.round(
            (procesados / item.totalRegistros) * 100
          );
          return `Procesando ${porcentaje}%`;
        }
        return "Procesando";
      }

      switch (item.status) {
        case "COMPLETED":
          return "Completado";
        case "COMPLETED_WITH_ERRORS":
          return "Completado con errores";
        case "FAILED":
          return "Fallido";
        default:
          return item.status;
      }
    },
    async abrirErrores(job) {
      this.jobSeleccionado = job;
      this.dialogErrores = true;
      this.loadingErrores = true;
      this.erroresJob = [];

      try {
        this.erroresJob = await getErroresJobEmisionesMasivas(job.id);
      } catch (error) {
        console.error(error);
        this.$toast.error("No se pudo consultar el detalle de errores.");
      } finally {
        this.loadingErrores = false;
      }
    },
  },
};
</script>

<style>
.celda-errores {
  position: relative;
  width: 100%;
}

.numero-errores,
.icono-ojo {
  cursor: pointer;
}

.icono-ojo {
  position: absolute;
  opacity: 0.8;
}

.icono-ojo:hover {
  opacity: 1;
}
</style>
